"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VERSIONS = void 0;
exports.DEFAULT_VERSIONS = {
    ISSUE: 3,
    TRANSFER: 3,
    REISSUE: 3,
    BURN: 3,
    EXCHANGE: 3,
    LEASE: 3,
    CANCEL_LEASE: 3,
    ALIAS: 3,
    MASS_TRANSFER: 2,
    DATA: 2,
    SET_SCRIPT: 2,
    SPONSORSHIP: 2,
    SET_ASSET_SCRIPT: 2,
    INVOKE_SCRIPT: 2,
    UPDATE_ASSET_INFO: 1,
    INVOKE_EXPRESSION: 1,
};
//# sourceMappingURL=defaultVersions.js.map